__turbopack_context__.v({
  "dialog-actions": "dialog-actions-module-scss-module___dtFRq__dialog-actions",
});
